import { Investment } from './../investments-extract/models/investment';
import { ListItem } from '../../../shared/list-confirmation/model/list-item';

export class Rescue {
	mainValue: number;
	yeldValue: number;
	tax: number;
	message: string;
	success: boolean;
	grossRepurchaseAmount: number;
	repurchaseAmount: number;

	resumeList: Array<ListItem>;

	constructor() {}

}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/master/investments/models/rescue.ts